import Link from 'next/link';
import { FC } from 'react';
import { useTheme } from 'styled-components';

import { EDocumentTemplate } from '@/components/modules/account-orders-document-page';
import { TQuestionnaireProlongations } from '@/types/questionnaires';

import { useTranslate } from '@/shared/hooks/use-translate';
import { PdfIcon } from '@/shared/ui/icons';
import { format } from '@/shared/utils/date';

import { StyledDetailsPaymentBillByCash } from '../styled';

type TDetailsPaymentItemProps = {
    prolongation: TQuestionnaireProlongations;
};

export const DetailsPaymentExtendItem: FC<TDetailsPaymentItemProps> = ({ prolongation }) => {
    const { t } = useTranslate();
    const { color } = useTheme();

    return (
        <StyledDetailsPaymentBillByCash>
            <div>
                <p>
                    <span> {t('На {term} дней', { term: prolongation.term })} </span>
                </p>
                <p> {format(prolongation.created_at)} </p>
            </div>
            <Link
                href={`/account/orders/document/${EDocumentTemplate.PROLONGATION}/${prolongation.document_id}`}
                target="_blank"
            >
                {t('Скачать PDF')} <PdfIcon color={color.primary} />
            </Link>
        </StyledDetailsPaymentBillByCash>
    );
};
